import { DropdownFieldLink } from '@cian/components';

import React, { memo } from 'react';

import { coworkingSwitchButtonsMapper } from '../../mappers/coworkingSwitchButtonsMapper';

import { useCoworkingOfferTypeChangeEffect } from './internal/hooks/useCoworkingOfferTypeChangeEffect';
import { useCoworkingPriceTypeDropdownBoundActions } from './internal/hooks/useCoworkingPriceTypeDropdownBoundActions';
import { useCoworkingPriceTypeSelector } from './internal/hooks/useCoworkingPriceTypeSelector';
import { useHandlePriceTypeChange } from './internal/hooks/useHandlePriceTypeChange';

export const CoworkingPriceTypeDropdown = memo(function CoworkingPriceTypeDropdown() {
  const priceType = useCoworkingPriceTypeSelector();

  const { setJsonQueryPriceType } = useCoworkingPriceTypeDropdownBoundActions();

  const handlePriceTypeChange = useHandlePriceTypeChange(setJsonQueryPriceType);

  useCoworkingOfferTypeChangeEffect(priceType, handlePriceTypeChange);

  return (
    <DropdownFieldLink onValueChange={handlePriceTypeChange} value={priceType} values={coworkingSwitchButtonsMapper} />
  );
});
